import { c as _c } from "react/compiler-runtime";
import { Box, HStack, Text } from '@chakra-ui/react';
import { CalendarEventCard } from '@src/components/sco/Events/EventCalendar/CalendarEventCard';
import { GroupEvent } from '@src/graphql-types';
import { isToday } from 'date-fns';
import moment from 'moment';
import React from 'react';
type EventCalendarDayProps = {
  date: Date | moment.Moment;
  events: GroupEvent[];
  onShowEventDetails?: (event: GroupEvent) => void;
};
export const EventCalendarDay = props => {
  const $ = _c(28);
  const t0 = `${isToday(moment(props.date).toDate()) ? "2px" : "1px"} solid`;
  const t1 = `${isToday(moment(props.date).toDate()) ? "colorPalette.focusRing" : "colorPalette.muted"}`;
  const t2 = moment(props.date).endOf("day").isAfter(moment()) ? 1 : 0.5;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      borderColor: "colorPalette.border"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== props.date) {
    t4 = moment(props.date).format("ddd");
    $[1] = props.date;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = <Box borderTopRadius="4px"><Text textStyle="label">{t4}</Text></Box>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== props.date) {
    t6 = moment(props.date).format("MMM D");
    $[5] = props.date;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <Box><Text textStyle="label">{t6}</Text></Box>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t7) {
    t8 = <HStack bgColor="colorPalette.bg" gap="2" justify="center" padding="3">{t5}{t7}</HStack>;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== props.events.length) {
    t9 = props.events.length === 0 && <Box color="colorPalette.fg/50" fontFamily="Poppins, sans-serif" fontSize="14px" textAlign="center">No events scheduled.</Box>;
    $[12] = props.events.length;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== props.events || $[15] !== props.onShowEventDetails) {
    let t11;
    if ($[17] !== props.onShowEventDetails) {
      t11 = event => <CalendarEventCard key={event.id} event={event} onShowDetails={props.onShowEventDetails} />;
      $[17] = props.onShowEventDetails;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    t10 = props.events.map(t11);
    $[14] = props.events;
    $[15] = props.onShowEventDetails;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <Box padding="3">{t9}{t10}</Box>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t0 || $[23] !== t1 || $[24] !== t11 || $[25] !== t2 || $[26] !== t8) {
    t12 = <Box bgColor="colorPalette.subtle" border={t0} borderColor={t1} borderRadius="md" opacity={t2} overflow="hidden" transition="background-color 0.2s ease-out" _hover={t3}>{t8}{t11}</Box>;
    $[22] = t0;
    $[23] = t1;
    $[24] = t11;
    $[25] = t2;
    $[26] = t8;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};